
import lazy from './lazy';
let runOnce = false;


const
get = function(selector) {
	return document.querySelector(selector);
},
create = function() {
	if (runOnce) return;
	runOnce = true;

	$.getScript('https://static-assets.mapbox.com/gl-pricing/dist/mapbox-gl.js', function() {

		mapboxgl.accessToken = 'pk.eyJ1IjoiamFtZXNyb2NrIiwiYSI6ImNqdTgzcG5odzB5NXc0NXFyY3ZreGVseXgifQ.JJdQ27Yu_7lPhy2fEoDsmw';

		var
		map = new mapboxgl.Map({
			container: 'map',
			pitch: 55.00,
			style: 'mapbox://styles/blackbridgecommunications/cjuml70h2096q1fqpqynnmq2z'
			// style: 'mapbox://styles/mapbox/streets-v9'
		}),
		bounds = new mapboxgl.LngLatBounds(),
		popup = get('#popup'),
		popupHeadingNode = get('#popup-heading'),
		popupImageNode = get('#popup-img'),
		popupBodyNode = get('#popup-body'),
		popupCloseNode = get('#popup-close'),
		popupLinkNode = get('#popup-link'),
		mapKey = get('#map-key'),
		fitToBounds = function() {

			map.fitBounds(bounds, {
				padding: {top: 200, bottom: 40, left: 40, right: 40},
				animate: false
			});

		};

		map.scrollZoom.disable();
		map.doubleClickZoom.disable();
		map.boxZoom.disable();
		map.dragPan.disable();
		map.touchZoomRotate.disable();

		map.on('resize', function() {

			fitToBounds();

		});

		popupCloseNode.addEventListener('click', function(e) {
			e.preventDefault();
			popup.setAttribute('data-open', 'false');
		});

		$(popup).on('click', function(e) {
			e.stopPropagation();
		});

		$(document).on('click', function (e) {
			popup.setAttribute('data-open', 'false');
		});

		map_json.markers.forEach(function(marker) {

			var el = document.createElement('div');
			el.className = ('marker ' + marker.category);

			el.addEventListener('click', function(e) {

				e.stopPropagation();

				popup.setAttribute('data-open', 'true');

				popupHeadingNode.innerHTML = marker.heading;
				popupBodyNode.innerHTML = marker.body;

				if (marker.img)  {
					popup.classList.add('has-image');
					popupImageNode.src = marker.img;
					popupImageNode.classList.remove('hidden');
				} else {
					popup.classList.remove('has-image');
					popupImageNode.classList.add('hidden');
				}
			});

			bounds.extend(marker.coordinates);

			new mapboxgl.Marker(el).setLngLat(marker.coordinates).addTo(map);

		});

		map_json.key.forEach(function(item) {

			var el = document.createElement('div');
			el.className = ('key-item ' + item.category);

			el.innerHTML = item.desc;

			mapKey.appendChild(el);

		});

		fitToBounds();

	});
};

export default function() {
	return this.lazyLoadOnScroll({
		handler: function() {
			create();
		}
	});
};
